/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { fetchCloudRun } from "../Helper";
import { store } from "@/store";
import { BotStore } from "@/store/constants";
import { getDoc, getFirestore, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { IIntent, IIntentActor, ILanguageValue } from "@chatcaptain/types/chatbot";

export const createIntent = async (name: string, flowId: string, blockId: string): Promise<string> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  const response = await fetchCloudRun("https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/intents", "POST", {}, {
    name,
    actor: {
      id: flowId + "/" + blockId,
      flow_id: flowId,
      block_id: blockId,
      name: "Block"
    } as IIntentActor,
    faq: false
  });
  return response.id;
}

export const deleteIntent = async (intentId: string): Promise<void> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await fetchCloudRun("https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/intents/" + intentId, "DELETE");
}

export const getIntent = async (intentId: string): Promise<IIntent | null> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  const document = await getDoc(doc(getFirestore(), "dialogs/" + chatbotId + "/intents/" + intentId));
  if(!document.exists) return null;
  const data = document.data() as IIntent;

  return {
    id: intentId,
    ...data
  };
}

export const updateIntent = async (id: string, name: string, intelligentEnquire: IIntent["intelligent_enquire"]) => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await updateDoc(doc(getFirestore(), "dialogs/" + chatbotId + "/intents/" + id), {
    updated: serverTimestamp(),
    name,
    intelligent_enquire: intelligentEnquire
  });
}
 
 /**
  * Adds the specified language
  * @param language as two-letter code (e.g. DE or EN)
  */
export const enableLanguage = async (language: string) => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await fetchCloudRun("https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/languages", "POST", {}, {
    language
  });
}

export const getDefaultIntelligentEnquireQuestion = async (): Promise<ILanguageValue<string> | string | null> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  const ie = await getDoc(doc(getFirestore(), "dialogs/" + chatbotId + "/settings/intelligent_enquire"));
  if(!ie.exists) return null;
  const question = ie.data()?.question;
  if(!question) return null;
  if(typeof question == "string") return question as string;
  return question as ILanguageValue<string>;
}